import { Helmet } from "react-helmet-async";

import { GOOGLE_ANALYTICS_MEASUREMENT_ID } from "../../constants/analyticsConfig";

export default function GoogleAnalyticsHeader() {
  return (
    <Helmet>
      {/* Without crossOrigin the browser withholds the message and stack from any throw inside this
          script, leaving telemetry only a bare "Script error." with no line, file or stack. */}
      <script
        async
        crossOrigin="anonymous"
        src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_MEASUREMENT_ID}`}
      ></script>
      <script>
        {`window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('consent', 'default', {
  'analytics_storage': 'denied',
  'ad_storage': 'denied',
  'ad_user_data': 'denied',
  'ad_personalization': 'denied',
  'wait_for_update': 500
});
gtag('js', new Date());
gtag('config', '${GOOGLE_ANALYTICS_MEASUREMENT_ID}');`}
      </script>
    </Helmet>
  );
}
